import {
  Tag,
  Switch,
  Button,
  Space,
  Popconfirm,
  Tooltip,
  Typography,
} from "antd";

import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import SearchDataIndex from "../../../context/share/SearchDataIndex";

const { Text } = Typography;

export default function columnAlert(toggleActive, deleteAlert, t) {
  const getDataIndex = SearchDataIndex();

  return [
    {
      title: t("alerts.tableColumn.date"),
      dataIndex: "date",
      key: "date",
      width: 180,
      fixed: "left",
      align: "left",
      render: (text) => (text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"),
    },
    {
      title: t("alerts.tableColumn.deviceName"),
      dataIndex: "deviceName",
      key: "deviceName",
      width: 320,
      fixed: "left",
      ellipsis: true,
      align: "left",
      ...getDataIndex("deviceName"),
      render: (text) => (
        <Tooltip title={text}>
          <Text strong ellipsis>
            {text || "-"}
          </Text>
        </Tooltip>
      ),
    },
    {
      title: t("alerts.tableColumn.eui"),
      dataIndex: "devEui",
      key: "devEui",
      width: 220,
      fixed: "left",
      align: "left",
      ...getDataIndex("devEui"),
      render: (text) => (
        <code style={{ color: "#1677ff", fontSize: 12 }}>{text || "-"}</code>
      ),
    },
    {
      title: t("alerts.tableColumn.description"),
      dataIndex: "description",
      key: "description",
      width: 260,
      ellipsis: true,
      align: "left",
      ...getDataIndex("description"),
    },
    {
      title: t("alerts.tableColumn.status"),
      dataIndex: "status",
      key: "status",
      width: 140,
      align: "left",
      ...getDataIndex("status"),
      render: (text) => {
        const color = text === "ON" ? "green" : "blue";
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: t("alerts.tableColumn.state"),
      dataIndex: "state",
      key: "state",
      width: 140,
      align: "left",
      ...getDataIndex("state"),
      render: (text) => {
        const color =
          text === "OK" ? "green" : text === "FAIL" ? "red" : "orange";
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: t("alerts.tableColumn.active"),
      dataIndex: "isActive",
      key: "isActive",
      width: 120,
      align: "left",
      render: (_, record) => (
        <Switch
          checked={record.isActive}
          onChange={() => toggleActive(record)}
        />
      ),
    },
    {
      title: t("alerts.tableColumn.locationName"),
      dataIndex: "locationName",
      key: "locationName",
      width: 220,
      ellipsis: true,
      align: "left",
      ...getDataIndex("locationName"),
    },
    {
      title: t("alerts.tableColumn.countryName"),
      dataIndex: "countryName",
      key: "countryName",
      width: 160,
      ellipsis: true,
      align: "left",
      ...getDataIndex("countryName"),
    },
    {
      title: t("alerts.tableColumn.departmentName"),
      dataIndex: "departmentName",
      key: "departmentName",
      width: 180,
      ellipsis: true,
      align: "left",
      ...getDataIndex("departmentName"),
    },
    {
      title: t("alerts.tableColumn.countyName"),
      dataIndex: "countyName",
      key: "countyName",
      width: 180,
      ellipsis: true,
      align: "left",
      ...getDataIndex("countyName"),
    },
    {
      title: t("alerts.tableColumn.options"),
      key: "options",
      width: 100,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small" style={{ justifyContent: "center", width: "100%" }}>
          <Popconfirm
            placement="topRight"
            title={t("alerts.deleteTitle")}
            description={t("alerts.deleteContent")}
            onConfirm={() => deleteAlert(record)}
            okText={t("global.yes")}
            cancelText={t("global.no")}
            okType="primary" // Esta línea es clave para heredar el color azul
          >
            <Tooltip title={t("alerts.delete")}>
              <Button
                type="default"
                className="square-btn btn-outline-red"
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];
}
